import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../../design-system";
import { DemoDealIntakeView } from "./DemoDealIntake";
import { DEMO_PROJECT_ID, buildDemoPendingProject, setFakeProject } from "./fakeProjects";
import classes from "./ModalGuidedDealIntake.module.less";

interface Props {
    open: boolean;
    onClose: () => void;
}

export const ModalGuidedDealIntake: React.FC<Props> = ({ open, onClose }) => {
    const [inReview, setInReview] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (projectName: string) => {
        // Stash a fake project in the in-memory registry so ProjectView's
        // getProject() call resolves to it, then land on its pending state.
        setFakeProject(buildDemoPendingProject(projectName));
        onClose();
        navigate(`/project/${DEMO_PROJECT_ID}/analysis/1`);
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={1200}
            destroyOnClose
            maskClosable={false}
            title={inReview ? "Review & submit" : "Intake"}
            className={classes.modal}
            centered={false}
            style={{ top: 64, paddingBottom: 0 }}
            maskStyle={{ background: "#222937", top: 64 }}
        >
            <div className={classes.body}>
                <DemoDealIntakeView
                    onSubmittedReturn={onClose}
                    onReviewModeChange={setInReview}
                    onSubmit={handleSubmit}
                />
            </div>
        </Modal>
    );
};
